import React from "react";
import "./App.css";

import '@smarthtmlelements/smart-elements/source/modules/smart.accordion.js';

declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      "smart-accordion": any;
    }
    interface IntrinsicElements {
      "smart-accordion-item": any;
    }
  }
}

const App: React.FC = () => {
  return (
    <div className="App">
      <smart-accordion>
        <smart-accordion-item label="First Item">First Item Content.</smart-accordion-item>
        <smart-accordion-item label="Second Item">Second Item Content.</smart-accordion-item>
        <smart-accordion-item label="Third Item">Third Item Content.</smart-accordion-item>
        <smart-accordion-item label="Fourth Item">Fourth Item Content.</smart-accordion-item>
      </smart-accordion>
    </div>
  );
}

export default App;
